const isDomElement = (obj) => !!(obj && obj.nodeType === 1);
export default isDomElement;